/**
 * senchado-product-recently-viewed — 「最近見た商品」
 *
 * データ源: localStorage `senchado_signals`（snippets/senchado-record-view.liquid が記録）。
 *   { v:1, visits:[ts], viewed:[{handle,title,at}] } / newest-first / 最大20 / TTL 30日。
 *   viewed[0] は現在商品（記録が先に走る）のため data-current-handle で除外する。
 * 画像・価格は /products/{handle}.js（Ajax Product API）で解決。
 * 履歴なし・解決全滅時はセクション hidden のまま（穴を開けない）。
 * 価格: Ajax系JSON の price は minor unit ×100（セント相当）で返る（2026-07-21 実測）。
 *   例: /products/{handle}.js の price=1036800 は実売¥10,368。円換算は /100 + Math.round。
 */
(function () {
  'use strict';

  var KEY = 'senchado_signals';

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function escapeAttr(str) { return escapeHtml(str); }
  function money(v) { return '¥' + Math.round(Number(v || 0) / 100).toLocaleString('ja-JP'); }
  // Shopify CDN は width/height/crop で任意サイズを取得できる。カードは正方形
  // （CSS: aspect-ratio 1/1 + object-fit cover）なので、サーバ側で正方形クロップして
  // 配信する。これで縦長・横長どちらのソースでも枠いっぱいの実解像度を確保できる。
  function sized(url, width) {
    if (!url) return '';
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    return url + sep + 'width=' + width + '&height=' + width + '&crop=center';
  }
  // DPR2-3 のスマホでもカード枠（168〜200px）が粗く見えないよう解像度候補を並べる。
  function srcset(url) {
    if (!url) return '';
    return [300, 450, 600, 900].map(function (w) {
      return sized(url, w) + ' ' + w + 'w';
    }).join(', ');
  }

  function readViewed() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY));
      if (!d || d.v !== 1 || !Array.isArray(d.viewed)) return [];
      return d.viewed.filter(function (x) { return x && x.handle; });
    } catch (e) {
      return [];
    }
  }

  function cardHtml(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var imgHtml = img
      ? '<img class="senchado-related__img" src="' + escapeAttr(sized(img, 600)) +
          '" srcset="' + escapeAttr(srcset(img)) +
          '" sizes="(min-width: 750px) 200px, 168px"' +
          ' alt="" loading="lazy" decoding="async" width="600" height="600">'
      : '<span class="senchado-related__img senchado-related__img--empty" aria-hidden="true"></span>';
    return '<a class="senchado-related__card" href="' + escapeAttr(p.url) + '">' +
      imgHtml +
      '<span class="senchado-related__name">' + escapeHtml(p.title) + '</span>' +
      '<span class="senchado-related__price">' + escapeHtml(money(p.price)) + '<span class="senchado-related__tax">（税込）</span></span>' +
    '</a>';
  }

  function boot() {
    document.querySelectorAll('[data-senchado-recently-viewed]').forEach(function (root) {
      if (root.dataset.booted) return;
      root.dataset.booted = '1';
      var current = root.dataset.currentHandle || '';
      var limit = parseInt(root.dataset.limit, 10) || 8;
      var rail = root.querySelector('[data-recently-viewed-rail]');
      if (!rail) return;

      var handles = readViewed()
        .filter(function (x) { return x.handle !== current; })
        .slice(0, limit)
        .map(function (x) { return x.handle; });
      if (!handles.length) return;

      Promise.all(handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js')
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { return null; });
      })).then(function (products) {
        var cards = products.filter(function (p) {
          if (!p || !p.url) return false;
          // BOX定期便ミラー子商品は履歴に出さない（源=record-viewでも弾くが、既存localStorage分の保険）
          if (p.type === '定期便BOX子') return false;
          var tags = p.tags;
          if (Array.isArray(tags) ? tags.indexOf('_box_child') !== -1
            : (typeof tags === 'string' && tags.indexOf('_box_child') !== -1)) return false;
          return true;
        });
        if (!cards.length) return;
        rail.innerHTML = cards.map(cardHtml).join('');
        root.hidden = false;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
